import React, { useState } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box, Paper } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CompDatabase from 'components/comp-database/CompDatabase';

const BoweryAppraisalAccordion = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Accordion expanded={expanded} onChange={(_, isExpanded) => setExpanded(isExpanded)} sx={{ mt: 2 }}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="bowery-appraisal-content"
        id="bowery-appraisal-header"
        sx={{ background: '#fafafa' }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="body1" component="div" sx={{ fontWeight: 600 }}>
            View Cap Rates
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Paper elevation={0} sx={{ mb: -4, pt: 1 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 500 }}>
            View and compare cap rates from recent Bowery appraisals in similar markets.
          </Typography>
        </Paper>
        <CompDatabase showCapRateSummary={true} />
      </AccordionDetails>
    </Accordion>
  );
};

export default BoweryAppraisalAccordion;
